import TableCheckpoints from "../../components/TableCheckpoints";
import { CheckpointV2 } from "../../types/checkpoint";
import {
  deleteCheckpointV2,
  getAllCheckpointsV2,
  updateFavoriteCheckpointV2,
} from "../../services/checkpoint";
import { Dialog, Notification } from "@rio-cloud/rio-uikit";
import { useDebounce } from "src/hooks/useDebounce";

import { useEffect, useState } from "react";
import { IStop } from "../RegisterRoute";
import CreateCheckpoint from "./Create";
import EditCheckpoint from "./Edit";

const PAGE_SIZE = 10;

interface Props {
  open: boolean;
  selected?: IStop;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleSelectCheckpoint: (stop?: IStop) => void;
  handleRemoveCheckpoint: (stop?: IStop) => void;
  stopTypes?: string[];
  type: "ORIGIN" | "STOP" | "DESTINY";
}

export interface isFavoriteCheckpoint {
  isFavorite: boolean;
  id: string;
}

const SelectCheckpoint = ({
  open,
  onClose,
  selected,
  handleSelectCheckpoint,
  stopTypes,
  type,
  handleRemoveCheckpoint,
}: Props) => {
  const [checkpoints, setCheckpoints] = useState<CheckpointV2[]>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const debouncedSearch = useDebounce(searchValue, 400);
  const [sort, setSort] = useState("desc");

  const [createCheckpointModal, setCreateCheckpointModal] = useState(false);
  const [editCheckpointModal, setEditCheckpointModal] = useState(false);

  const [checkpointToEdit, setCheckpointToEdit] = useState<CheckpointV2>();
  const [filterByType, setFilterByType] = useState<string>("ALL");

  const initialData = async (signal?: AbortSignal) => {
    try {
      const response = await getAllCheckpointsV2(
        selected?.category,
        page,
        PAGE_SIZE,
        debouncedSearch
      );

      if (response.data.result) {
        setCheckpoints(response.data.result.values);
        setPages(response.data.result.totalPages);
      }
    } catch (error) {
      if ((error as any).name !== "CanceledError") console.error("Não foi possível buscar os checklist de parada.", error);
    }
  };

  const handleOpenCheckpointModal = () => {
    setCreateCheckpointModal(true);
  };

  const handleDelete = async (id?: string) => {
    try {
      await deleteCheckpointV2(id as string);
      Notification.success("Checklist deletado com sucesso.");
      await initialData();
    } catch (error) {
      Notification.error("Não foi possível deletar o checklist.");
    }
  };

  const handleUpdateCheckpoint = (id?: string) => {
    setCheckpointToEdit(checkpoints.find((checkpoint) => checkpoint.id === id));
    setEditCheckpointModal(true);
  };

  const handleFavorite = async (checkpoint: isFavoriteCheckpoint) => {
    try {
      await updateFavoriteCheckpointV2(checkpoint.id, {
        isFavorite: checkpoint.isFavorite,
      });
      initialData();
    } catch (error) {
      Notification.error("Não foi possível favoritar o checklist.");
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    initialData(signal);
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, debouncedSearch, sort, filterByType, open, createCheckpointModal, editCheckpointModal]);

  return (
    <>
      <Dialog
        show={open}
        onClose={() => onClose(false)}
        onEsc={() => onClose(false)}
        bsSize="xl"
        className="checkpointDialog"
        bodyClassName="padding-25 min-height-200"
        title="Checklist de parada"
        body={
          <TableCheckpoints
            page={page}
            pages={pages}
            pageSize={PAGE_SIZE}
            handlePage={(params: { page: number, pages?: number }) => {
              setPage(params.page);
            }}

            handleFavorite={handleFavorite}
            viewType={"TABLE"}
            selected={selected}
            rows={checkpoints}
            handleSelect={handleSelectCheckpoint}
            searchValue={searchValue}
            handleSearchValueChange={(text) => setSearchValue(text)}
            handleSort={(dir, _) => {
              setSort(dir);
            }}
            handleCreateCheckpoint={handleOpenCheckpointModal}
            handleDelete={handleDelete}
            handleUpdateCheckpoint={handleUpdateCheckpoint}
            handleRemove={handleRemoveCheckpoint}
          />
        }
      />

      <CreateCheckpoint
        open={createCheckpointModal}
        onClose={setCreateCheckpointModal}
        stopType={selected?.category ?? "REFUELING"}
      />

      {checkpointToEdit && (
        <EditCheckpoint open={editCheckpointModal} onClose={setEditCheckpointModal} checkpoint={checkpointToEdit} />
      )}
    </>
  );
};

export default SelectCheckpoint;
